/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'label-buildings': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<defs><path pid="0" d="M3.6.014l10.8 3.412V5.4H18V18H0V9h3.6V.014zM5.4 14.4H1.8v1.8h3.6v-1.8zm10.8 0h-1.8v1.8h1.8v-1.8zM5.4 10.8H1.8v1.8h3.6v-1.8zm10.8 0h-1.8v1.8h1.8v-1.8zM11.7 9H8.1v1.8h3.6V9zm4.5-1.8h-1.8V9h1.8V7.2zm-4.5-1.8H6.3v1.8h5.4V5.4z" id="svgicon_label-buildings_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_label-buildings_b" _fill="#fff"><use xlink:href="#svgicon_label-buildings_a"/></mask><path pid="1" _fill="#F4633A" fill-rule="nonzero" mask="url(#svgicon_label-buildings_b)" d="M-1.8-1.8h21.6v21.6H-1.8z"/></g>'
  }
})
